module.exports = __webpack_public_path__ + "static/media/hd-logo.ba84a20f.png";